import SideBarTool from "@/commons/components/side-bar-tool";
import { Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { MAJOR } from "@/commons/constants/major";
import { getMaterialsByprojectUuid } from "@/api/spec-common/material";
import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import genUUID from "@/commons/utils/gen-uuid";
import { Layer } from "@/commons/interface/geometry/layer";
import { LineType } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { STRUCTURE_SIGNAL } from "@/passets/structure-engine/enums/structure-signal";
import { STRUCTURE_SUB_CONTROL } from "@/passets/structure-engine/enums/structure-sub-control";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import TnMessage from "@/commons/widget/message";
import { STRUCTURE_CTRL_TYPE } from "@/passets/structure-engine/enums/structure-control-type";
import './index.less';
import { LayerType } from "@/commons/enums/layer-type";

/**
 * 结构板
 */
export default function SFloorPanel() {
    const { projectUuid, modelUuid } = useParams();
    const [materials, setMaterials] = useState<PMaterial[]>([]); // 材料列表
    const [selMaterial, setSelMaterial] = useState<PMaterial>(null);
    const [ez, setEz] = useState<number>(0);
    const [thickness, setThickness] = useState<number>(10);


    useEffect(() => {
        if (!projectUuid) return;
        getMaterialsByprojectUuid(projectUuid, MAJOR.STRUCTURE).then(res => {
            if (res.status == 200) {
                let materials = res.data || [];
                setMaterials(materials);
            }
        }).catch(() => {
            message.error("获得材料列表失败")
        })
    }, [projectUuid])

    const onMaterialChange = (uuid: string) => {
        let material = materials.find(item => item.uuid == uuid);
        setSelMaterial(material);
    }

    // 点击了布置按钮
    const assemble = () => {
        if (selMaterial == null) {
            TnMessage.error("请选择材料");
            return;
        }
        findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
            let layers: Layer[] = res.data || [];
            let componentLayer = layers?.find(item => item?.type === LayerType.SFLOOR);
            if (!!componentLayer) {
                // 存在一个图层为构件图层，绘制的图元都在该图层中
                handleAssemble(componentLayer.uuid);
            } else {
                // 不存在一个图层为构件图层，新建一个图层作为构件图层，绘制的图元都在该图层中
                let uuid = genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: "结构板",
                    color: "#000000",
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    projectUuid: projectUuid,
                    originLayer: false,
                    type: LayerType.SFLOOR,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(res => {
                    if (res.status === 200) {
                        graphicStore.context.layerContext.addLayer(newLayer);
                        handleAssemble(newLayer.uuid);
                    }
                }).catch(err => {
                    message.error("无法置为构件图层");
                    console.log(err);
                })
            }
        })
    }

    const handleAssemble = (layerUuid: string) => {
        const data = {
            materialUuid: selMaterial.uuid,
            ez: ez,
            layerUuid: layerUuid,
            thickness: thickness
        }

        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl
            || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== STRUCTURE_CTRL_TYPE.ADD_SFLOOR) {
            // 激活布置构件的二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl(STRUCTURE_SUB_CONTROL.ADDSFLOORCONTROL.name);

        }
        graphicStore.extraContext.listeners.getSignal(STRUCTURE_SIGNAL.initSFloorControl).dispatch(data);
    }

    const onEzChange = (e: any) => {
        const value = e.target.value;
        if (value == null || value === "" || isNaN(value)) {
            setEz(0);
            return;
        }
        setEz(parseFloat(value));
    }

    const onThicknessChange = (e: any) => {
        let value = e.target.value;
        if (value == null || value === "" || isNaN(value) || value <= 0) {
            value = 1;
        }
        setThickness(parseFloat(value));
    }

    return (
        <div className="side-bar-main floor-panel">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    板
                </div>
                <div className="detail structure-beam-panel">
                    <div className="row compact">
                        <div className="label">材料:</div>
                        <Select
                            size='small'
                            className="select-box"
                            placeholder='材料'
                            onChange={onMaterialChange}
                        >
                            {materials.map((item, index) => (
                                <Select.Option key={index} label={item?.name} value={item?.uuid}>
                                    {item?.name || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="row compact">
                        <div className="label">厚度(mm):</div>
                        <Input
                            size='small'
                            value={thickness}
                            className="input-box"
                            placeholder='厚度(mm)'
                            onChange={onThicknessChange}
                        />
                    </div>
                    <div className="row compact">
                        <div className="label">轴偏移ez(mm):</div>
                        <Input
                            size='small'
                            value={ez}
                            className="input-box"
                            placeholder='轴偏移ez(mm)'
                            onChange={onEzChange}
                        />
                    </div>
                    <div className='bottom-footer'>
                        <div className="ope-btn">
                            <div className="insert-button" onClick={assemble}>
                                <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                                <div className="text">布置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}